"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var setRowsFlagStateHelper_1 = require("./helpers/setRowsFlagStateHelper");
var applyConversationFlag_1 = require("owa-mail-list-actions/lib/actions/triage/applyConversationFlag");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var flagConversationService_1 = require("owa-mail-store/lib/services/flagConversationService");
var owa_service_error_1 = require("owa-service-error");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var owa_mail_store_1 = require("owa-mail-store");
var owa_mail_actions_1 = require("owa-mail-actions");
var SetConversationsFlagStateActionName = 'setConversationsFlagState';
/**
 * Set the specified flag state on a collection of conversations.
 * @param conversationRowKeys - the converations row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
var setConversationsFlagStateInternal = legacy_1.action(SetConversationsFlagStateActionName, datapoints_1.default.setConversationsFlagStateDatapoint)(function setConversationsFlagStateInternal(conversationRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(conversationRowKeys, tableViewId);
    owa_service_error_1.handleServiceError(SetConversationsFlagStateActionName, owa_mail_strings_1.default.errorFlaggingConversation, function () {
        var conversationActionContexts = conversationRowKeys.map(function (rowKey) {
            return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, tableViewId);
        });
        var flagType = {
            FlagStatus: flagStatusToApply,
        };
        // update list view store
        applyConversationFlag_1.default(conversationRowKeys, flagType, tableViewId);
        // update reading pane store
        stitch_1.raiseAction(owa_mail_store_1.ApplyConversationFlagStateStoreUpdateActionName)(conversationIdStrings, flagType, tableViewId);
        var tableView = Store_1.default.tableViews.get(tableViewId);
        // Do not specify folderId in search, so that action is global to the same conversation in all folders.
        var sourceFolderId = tableView.serverFolderId;
        var instrumentationFlag;
        switch (flagStatusToApply) {
            case 'Flagged':
                instrumentationFlag = 'Flag';
                break;
            case 'NotFlagged':
                instrumentationFlag = 'FlagCleared';
                break;
            case 'Complete':
                instrumentationFlag = 'FlagComplete';
                break;
        }
        owa_mail_actions_1.userMailInteractionAction(instrumentationFlag, instrumentationContexts);
        return flagConversationService_1.flagConversationService(conversationActionContexts, flagType, sourceFolderId);
    });
});
/**
 * Set the specified flag state on a collection of conversations.
 * @param conversationRowKeys - the converations row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
function setConversationsFlagState(conversationRowKeys, instrumentationContexts, tableViewId, flagStatusToApply) {
    setRowsFlagStateHelper_1.default(conversationRowKeys, tableViewId, flagStatusToApply, function (rowKeys, flagStatusToApply) {
        setConversationsFlagStateInternal(rowKeys, instrumentationContexts, tableViewId, flagStatusToApply);
    });
}
exports.default = setConversationsFlagState;
//# sourceMappingURL=setConversationsFlagState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/setConversationsFlagState.js
// module id = 5588
// module chunks = 62